
import { defineComponent, computed, ref } from "vue";
import { IonButton, IonPopover, IonItem, IonText } from "@ionic/vue";
import TradeRepository from "@/repositories/TradeRepository";

export default defineComponent({
  components: { IonButton, IonPopover, IonItem, IonText },

  setup() {
    const trades = computed(() => TradeRepository.selectedTrades());

    const type = TradeRepository.type();

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const isOpenRef = ref(false);
    const event = ref();
    const setOpen = (state: boolean, ev?: Event) => {
      event.value = ev;
      isOpenRef.value = state;
    };

    return {
      trades,
      type,
      monthNames,
      isOpenRef,
      event,
      setOpen,
    };
  },
});
